export default "__VITE_ASSET__DegsDLmt__"